module.exports = __webpack_public_path__ + "img/145.163c2e8e.jpg";